export function loadScript(src: string, id: string) {
    let test = document.getElementById(id);
    if (test) {
         return false;

    }
     const script = document.createElement("script");
    script.src = src;
    script.id = id;
     script.async = true;


    document.body.appendChild(script);
    return true;
}
